export const handleCopyClick = async (textToCopy, setCopyStatus) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 2000); // Reset copy status after 2 seconds
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
};

export const handleShareClick = async (title, text, url) => {
    if (navigator.share) {
        try {
            await navigator.share({
                title: title,
                text: text,
                url: url
            });
        } catch (error) {
            console.error('Error sharing:', error);
        }
    } else {
        alert('Sharing not supported on this browser. Please copy the URL manually.');
    }
};

export const getCurrencyInfo = (currency) => {
    let name, code, symbol, icon;

    switch (currency) {
        case 'INR':
            name = 'Indian Rupees';
            code = 'INR';
            symbol = '₹';
            icon = '';
            break;
        case 'USD':
            name = 'US Dollars';
            code = 'USD';
            symbol = '$';
            icon = '';
            break;
        case 'EUR':
            name = 'Euro';
            code = 'EUR';
            symbol = '€';
            icon = '';
            break;
        case 'GBP':
            name = 'British Pound';
            code = 'GBP';
            symbol = '£';
            icon = '';
            break;
        case 'HUF':
            name = 'Hungarian Forint';
            code = 'HUF';
            symbol = 'Ft';
            icon = '';
            break;
        case 'JPY':
            name = 'Japanese Yen';
            code = 'JPY';
            symbol = '¥';
            icon = '';
            break;
        default:
            name = 'Unknown';
            code = 'UNIT';
            symbol = '?';
            icon = '';
            break;
    }

    return { name, code, symbol, icon };
};

export const getShareLink = (url, title, name, sm) => {
    switch (sm) {
        case "facebook":
            return `https://www.facebook.com/sharer.php?u=${url}`;
            break;
        case "twitter":
            return `https://twitter.com/share?url=${url}&text=${title}&via=TheSmartWare&hashtags=${title}`;
            break;
        case "google":
            return `https://plus.google.com/share?url=${url}`;
            break;
        case "whatsapp":
            return `https://wa.me/?text=${title}${url}`;
            break;
        case "pinterest":
            return `https://pinterest.com/pin/create/bookmarklet/?media=[post-img]&url=${url}&is_video=[is_video]&description=${title}`;
            break;
        case "linkedin":
            return `https://www.linkedin.com/shareArticle?url=${url}&title=${title}`;
            break;
        case "buffer":
            return `https://bufferapp.com/add?text=${title}&url=${url}`;
            break;
        case "tumblr":
            return `https://www.tumblr.com/share/link?url=${url}&name=${title}&description=[post-desc]`;
            break;
        case "reddit":
            return `https://reddit.com/submit?url=${url}&title=${title}`;
            break;
        case "stumbleupon":
            return `https://www.stumbleupon.com/submit?url=${url}&title=${title}`;
            break;
        case "delicious":
            return `https://delicious.com/save?v=5&provider=[provider]&noui&jump=close&url=${url}&title=${title}`;
            break;
        case "evernote":
            return `https://www.evernote.com/clip.action?url=${url}&title=${title}`;
            break;
        case "wordpress":
            return `https://wordpress.com/press-this.php?u=${url}&t=${title}&s=[post-desc]&i=[post-img]`;
            break;
        case "pocket":
            return `https://getpocket.com/save?url=${url}&title=${title}`;
            break;
        case "telegram":
            return `https://t.me/share/url?url=${url}&text=${title}`;
            break;

        default:
            return `mailto:?&amp;subject=${title}&amp;body=Hi,%0A%0ACheck%20out%20%20this%20article%20on%20${name}:%20%20%0A%0A".${url}`;
    }
}
